import React from "react";
import { Check } from "lucide-react";

const POINTS = [
  "Tidak Perlu Upah Designer Buatkan Design",
  "Tidak Perlu Sediakan Fail Artwork Sendiri",
];

export const BenefitStrip = ({ variant = "hero", testId }) => (
  <ul
    className={`grid gap-2.5 sm:grid-cols-2 rounded-2xl border p-4 ${
      variant === "hero"
        ? "border-[#c79a3b]/35 bg-gradient-to-r from-[#fdf8ec] to-white"
        : "border-[#0f3f2f]/12 bg-white/80"
    }`}
    data-testid={testId}
  >
    {POINTS.map((p) => (
      <li key={p} className="flex items-start gap-2.5">
        <span className="mt-0.5 grid place-items-center h-5 w-5 shrink-0 rounded-full bg-[#0f3f2f] text-white">
          <Check strokeWidth={2.5} className="h-3 w-3" />
        </span>
        <span className="text-sm font-semibold text-[#14201b] leading-snug">{p}</span>
      </li>
    ))}
  </ul>
);
